export const ServiceCallInviteModalTranslation = {
  fi: {
    ServiceCallInviteModal: {
      title: 'Huoltokutsu',
      name: 'Nimi / tunniste',
      registerNumber: 'Rekisterinumero',
      brand: 'Merkki',
      model: 'Malli',
      emptyValue: '–',
      titleLabel: 'Huoltokutsun otsikko (käytetään myös luotavan muistutuksen otsikkona)',
      bodyLabel: 'Huoltokutsun aihe',
      dateLabel: 'Päivämäärä',
      timeLabel: 'Kellonaika',
      submit: 'Lähetä',
      cancel: 'Peruuta',
      requiredError: 'Täytä kaikki pakolliset kentät.',
      success: 'Huoltokutsu lähetetty.',
    },
  },
};
